import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import PrivateRoute from 'app/components/auth/PrivateRoute';
import PublicRoute from 'app/components/auth/PublicRoute';
import TeamViewPrivateRoute from 'app/products/team-view/components/auth/PrivateRoute';
import TeamViewPublicRoute from 'app/products/team-view/components/auth/PublicRoute';

import OnBoardingLayout from 'app/features/on-boarding/OnBoardingLayout';
import AuthenticationLayout from 'app/features/authentication/AuthenticationLayout';
import DashboardLayout from 'app/features/dashboard/DashboardLayout';
import ManageClubLayout from 'app/features/manage-club/ManageClubLayout';
import ManageTeamLayout from 'app/features/manage-team/ManageTeamLayout';
import ProfileLayout from 'app/features/profile/ProfileLayout';
import TeamsLayout from 'app/features/teams/TeamsLayout';
import ClubsLayout from 'app/features/clubs/ClubsLayout';
import PaymentsLayout from 'app/features/payments/PaymentsLayout';
import PaymentRequestsLayout from 'app/features/payment-requests/PaymentRequestsLayout';
import CollectLayout from 'app/features/collect/CollectLayout';
import BulkPaymentsLayout from 'app/features/bulk-payments/BulkPaymentsLayout';
import ListPaymentsLayout from 'app/features/list-payments/ListPaymentsLayout';
import MakePaymentLayout from 'app/features/make-payment/MakePaymentLayout';
import ConnectTeamLayout from 'app/features/connect-team/ConnectTeamLayout';
import ForfeitsLayout from 'app/features/forfeits/ForfeitsLayout';
import TeamMembersLayout from 'app/features/team-members/TeamMembersLayout';
import ReportsLayout from 'app/features/reports/ReportsLayout';
import PayoutsLayout from 'app/features/payouts/PayoutsLayout';
import ImportsLayout from 'app/features/imports/ImportsLayout';
import MatchPaymentsLayout from 'app/features/match-payment/MatchPaymentsLayout';

// Team view
import TeamViewLayout from 'app/products/team-view/TeamViewLayout';
import NotFoundView from 'app/components/layout/NotFound';
import MaintenanceView from 'app/components/layout/Maintenance';
import UnexpectedErrorView from 'app/components/layout/UnexpectedError';
import Trigger500 from 'app/components/general/Trigger500';

import { IUsersSelector } from 'app/ducks/users/types';

interface IRouteProps {
  flags: any;
  ldClient: any;
  users: IUsersSelector;
  authentication: any;
  actions: any;
  location: any;
  loading: any;
  notifications: any;
  global: any;
  match: any;
  appUpdateAvailable: boolean;
}

export default class Routes extends React.Component<IRouteProps, {}> {
  previousLocation;

  previousPath;

  static defaultProps: IRouteProps = {
    flags: undefined,
    users: undefined,
    authentication: undefined,
    actions: undefined,
    loading: undefined,
    notifications: undefined,
    global: undefined,
    location: undefined,
    match: undefined,
    appUpdateAvailable: false,
  };

  constructor(props) {
    super(props);
    this.previousLocation = this.props.location;
    this.previousPath = this.props.location.state?.previousPath;
  }

  componentWillUpdate(): void {
    const { location } = this.props;

    if (!(location.state && location.state.modal)) {
      this.previousLocation = location;
    }
    const previousPath = location.state?.previousPath;
    if (previousPath !== undefined) {
      this.previousPath = previousPath;
    }
  }

  render(): React.ReactNode {
    const { host } = window.location;
    const { protocol } = window.location;
    const parts = host.split('.');
    let subdomain = '';
    if (parts.length >= 3) {
      subdomain = parts[0];
    }
    if (subdomain === 'your') {
      return (
        <Switch>
          <PublicRoute
            exact
            path={[
              '/:teamCode',
              '/:teamCode/join-team',
              '/:teamCode/:teamMemberCode',
              '/:teamCode/:teamMemberCode/overview',
              '/:teamCode/:teamMemberCode/payment-history',
              '/:teamCode/:teamMemberCode/your-details']}
            component={TeamViewLayout}
          />
          <TeamViewPublicRoute exact path="/404" component={NotFoundView} />
        </Switch>
      );
    }

    const { location } = this.props;
    const isModal = (
      location.state
      && location.state.modal
      && this.previousLocation !== location
    );

    const { previousPath } = this;
    return (
      <>
        <Switch location={isModal ? this.previousLocation : location}>
          <PublicRoute exact path="/login" component={AuthenticationLayout} />
          <PublicRoute
            exact
            path="/forgot-password"
            component={AuthenticationLayout}
          />
          <PublicRoute
            exact
            path="/forgot-password/confirm"
            component={AuthenticationLayout}
          />
          <PublicRoute exact path="/404" component={NotFoundView} />
          <PublicRoute exact path="/maintenance" component={MaintenanceView} />
          <PublicRoute exact path="/unexpected-error" component={UnexpectedErrorView} />
          <PublicRoute path="/sign-up" component={OnBoardingLayout} />
          <PublicRoute
            exact
            path={[
              '/get-started',
              '/get-started/personal',
              '/get-started/verify',
              '/get-started/club',
            ]}
            component={OnBoardingLayout}
          />

          <PublicRoute
            exact
            path={[
              '/get-started/connect',
              '/get-started/share',
              '/get-started/account',
            ]}
            component={OnBoardingLayout}
          />
          <PrivateRoute
            exact
            actions={this.props.actions}
            path="/team-members/detail/:teamMemberId"
            component={TeamMembersLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/team-members', '/team-members\\::filterConfig']}
            component={TeamMembersLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={[
              '/import/team-members',
              '/import/team-members/map',
              '/import/team-members/review/:bulkImportId',
            ]}
            component={ImportsLayout}
          />
          <PublicRoute
            path="/get-started/connect/:orgConnectionCode"
            component={OnBoardingLayout}
          />

          {/* <PrivateRoute
          actions={this.props.actions}
          exact
          path={['/dashboard', '/']}
          component={MyDashboardLayout}
        /> */}
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/dashboard', '']}
            component={DashboardLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={[
              '/reports',
              '/reports/:reportType',
            ]}
            component={ReportsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/payouts/detail/:payoutId"
            component={PayoutsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/payouts', '/payouts\\::filterConfig']}
            component={PayoutsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/manage-team"
            component={ManageTeamLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/manage-club"
            component={ManageClubLayout}
          />

          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/list-payments"
            component={ListPaymentsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/connect-team', '/connect-team/confirm']}
            component={ConnectTeamLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/matches/pay-multiple']}
            component={BulkPaymentsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/profile/:sub"
            component={ProfileLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/profile"
            component={ProfileLayout}
          />

          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/teams"
            component={TeamsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/teams/:teamId/edit"
            component={TeamsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/create-team"
            component={TeamsLayout}
          />

          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/teams/detail/:teamId"
            component={TeamsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/payment/match/detail/:matchPaymentId"
            component={MatchPaymentsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/teams', '/teams\\::filterConfig']}
            component={TeamsLayout}
          />

          <PrivateRoute
            actions={this.props.actions}
            exact
            path="/clubs"
            component={ClubsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/clubs/:clubId/edit"
            component={ClubsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/create-club"
            component={ClubsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            exact
            path={['/payment-requests',
              '/payment-requests\\::filterConfig',
              '/payment-requests/new',
              '/payment-requests/:paymentRequestId/update',
              '/payment-requests/:paymentRequestId/update/confirm',
              '/payment-requests/new\\::preconfigData',
              '/payment-requests/new/select\\::preconfigData',
              '/payment-requests/new/confirm\\::preconfigData',
              '/payment-requests/new/:subaction',
              '/payment-requests/detail/:paymentRequestId',
              '/payment-requests/detail/:action/collection/:subaction']}
            component={PaymentRequestsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/payments/:paymentId"
            component={PaymentsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path="/collect"
            component={CollectLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path={[
              '/payment/match/:matchPaymentId/review',
              '/payment/match/:matchPaymentId/pay',
              '/payment/match/:matchPaymentId/receipt',
              '/payment/match/add/:matchPaymentId/review',
              '/payment/match/add/:matchPaymentId/pay',
              '/payment/match/add/:matchPaymentId/receipt',
              '/payment/multiple-matches/:bulkMatchPaymentId/review',
              '/payment/multiple-matches/:bulkMatchPaymentId/pay',
              '/payment/multiple-matches/:bulkMatchPaymentId/receipt',
              '/payment/forfeit/:forfeitId/review',
              '/payment/forfeit/:forfeitId/pay',
              '/payment/forfeit/:forfeitId/receipt',
            ]}
            component={MakePaymentLayout}
          />

          <PrivateRoute
            actions={this.props.actions}
            path={['/forfeit/:paymentEventId/:groupId/submit']}
            component={ForfeitsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path={['/forfeit/select']}
            component={ForfeitsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path={['/forfeit/covid/select']}
            component={ForfeitsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path={['/forfeit/:paymentEventId/:groupId/submit', '/forfeit/:paymentEventId/:groupId/submit/covid']}
            component={ForfeitsLayout}
          />
          <PrivateRoute
            actions={this.props.actions}
            path={['/forfeit/confirm/covid/:forfeitId']}
            component={ForfeitsLayout}
          />
          <Route path="/trigger500" component={Trigger500} />

          <Redirect from="*" to="/404" />
        </Switch>
        {
          isModal
            ? (
              <PrivateRoute
                actions={this.props.actions}
                exact
                fullModal
                isModal={isModal}
                previousPath={previousPath}
                path={[
                  '/import/team-members',
                  '/import/team-members/map',
                  '/import/team-members/review/:bulkImportId',
                ]}
                component={ImportsLayout}
              />
            ) : null
        }
      </>
    );
  }
}
